function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);























































// JS MODIFIED FOR DOTS
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.dotsContainer = this.querySelector('.custom-dots-container');

    if (!this.slider || !this.dotsContainer) {
      console.error('Slider or dots container not found.');
      return;
    }

    console.log('Slider and dots container found.');

    this.initPages();
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', () => this.update());

    this.dotsContainer.addEventListener('click', (event) => this.onDotClick(event));

    console.log('Slider component initialized.');
  }

  initPages() {
    const totalSlides = this.slider.children.length; // Nombre de slides
    this.totalPages = totalSlides;
    this.currentPage = 1; // Par défaut, pas de dot actif

    console.log('Pages initialized. Total slides:', totalSlides);
  }

  update() {
    const sliderRect = this.slider.getBoundingClientRect();
    const slideWidth = sliderRect.width;
    const currentIndex = Math.round(this.slider.scrollLeft / slideWidth);
    this.currentPage = currentIndex + 1;

    console.log('Slider updated. Current page:', this.currentPage);
    
    const event = new CustomEvent('onSliderPageChanged', { detail: (this.currentPage - 1)});
    document.dispatchEvent(event);
  }

  onDotClick(event) {
    const dot = event.target.closest('.custom-dot');
    if (!dot) return;

    const slideIndex = parseInt(dot.dataset.slideIndex);
    this.currentPage = slideIndex;

    const slideToPosition = (slideIndex - 1) * this.slider.clientWidth;
    this.setSlidePosition(slideToPosition);

    console.log('Dot clicked. Navigating to slide index:', slideIndex);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });

    console.log('Setting slide position:', position);
  }
}

customElements.define('slider-component', SliderComponent);





document.addEventListener("DOMContentLoaded", function() {
  const dots = document.querySelectorAll('.custom-dot');

  // Par défaut, active le premier dot
  dots[0]?.classList?.add('active');

  dots.forEach(dot => {
    dot.addEventListener('click', function() {
      // Retire la classe active de tous les autres dots
      dots.forEach(otherDot => otherDot.classList.remove('active'));

      // Ajoute la classe active au dot cliqué
      this.classList.add('active');
    });
  });
});













































class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        // Check coming soon state from re-fetched HTML
        const comingSoonSource = html.getElementById(`ComingSoon-${sectionId}`);
        const isComingSoon = comingSoonSource && comingSoonSource.dataset.comingSoon === 'true';

        // Update the price block from re-fetched HTML (handles coming soon vs normal price)
        const priceDestination = document.getElementById(`price-${this.dataset.section}`);
        const priceSource = html.getElementById(`price-${sectionId}`);
        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
          priceDestination.classList.remove('hidden');
        }

        // Toggle visibility of add-to-cart form vs coming-soon container
        const productFormEl = document.getElementById(`product-form-${this.dataset.section}`);
        const comingSoonContainer = document.getElementById(`ComingSoonContainer-${this.dataset.section}`);
        if (productFormEl) productFormEl.closest('product-form').style.display = isComingSoon ? 'none' : '';
        if (comingSoonContainer) comingSoonContainer.style.display = isComingSoon ? '' : 'none';

        // Update the local ComingSoon indicator
        const comingSoonDestination = document.getElementById(`ComingSoon-${this.dataset.section}`);
        if (comingSoonDestination) comingSoonDestination.dataset.comingSoon = isComingSoon ? 'true' : 'false';

        // Update product-info data attribute for CSS-driven price swap
        const productInfoEl = document.getElementById(`ProductInfo-${this.dataset.section}`);
        if (productInfoEl) productInfoEl.dataset.comingSoon = isComingSoon ? 'true' : 'false';

        // Refresh the STORE AVAILABILITIES accordion for the new variant.
        // Only the inner content is swapped so the accordion's open/closed
        // state (inline display on .accordion-content) is preserved.
        const storeAvailSource = html.querySelector('[data-store-availability] .accordion-content');
        const storeAvailDestination = document.querySelector('[data-store-availability] .accordion-content');
        if (storeAvailSource && storeAvailDestination) {
          storeAvailDestination.innerHTML = storeAvailSource.innerHTML;
        }

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        if (isComingSoon) {
          this.toggleAddButton(true, window.variantStrings.comingSoon);
        } else {
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
          );
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const mainContent = document.querySelector('main#MainContent');
    const footerSection = document.querySelector('.footer-section');
    const copyrightSection = document.querySelector('.thefooter');
    const header = document.querySelector('.animate-header');

    const nav = document.querySelector('.header__inline-menu');

    if (!nav) return;

    if (nav.querySelector('.tmenu_wrapper')) {
      nav.addEventListener('mouseover', () => {
        mainContent?.classList.remove('no-blur');
        footerSection?.classList.remove('no-blur');
        copyrightSection?.classList.remove('no-blur');
        mainContent?.classList.add('blur-effect');
        footerSection?.classList.add('blur-effect');
        copyrightSection?.classList.add('blur-effect');

        if (header) {
          header.classList.add('header-wrapper-white');
          header.classList.remove('header-wrapper-transparent');
        }
      });

      nav.addEventListener('mouseleave', () => {
        const searchModal = document.querySelector('.modal-overlay');
        const computedStyle = window.getComputedStyle(searchModal);

        if (computedStyle?.display === 'block') {
          return;
        }
        
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        mainContent?.classList.remove('blur-effect');
        footerSection?.classList.remove('blur-effect');
        copyrightSection?.classList.remove('blur-effect');
        mainContent?.classList.add('no-blur');
        footerSection?.classList.add('no-blur');
        copyrightSection?.classList.add('no-blur');

        if (header && scrollTop < 1) {
          header.classList.remove('header-wrapper-white');
          header.classList.add('header-wrapper-transparent');
        }
      });

      if (scrollTop < 1 && header) {
        header.classList.add('header-wrapper-transparent');
      }
    }
  }, 800);
});

// Supprimer les info bulles sur les liens dans le header

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    document.querySelectorAll('.tmenu_item_link').forEach(element => {
      element.addEventListener('mouseover', function() {
        this.removeAttribute('title');
      });
    });
  }, 300);
});

(function () {
  const isTouchDevice =
    window.matchMedia('(pointer: coarse)').matches ||
    'ontouchstart' in window;

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const ACTIVATE_THRESHOLD = 8;
  const TOGGLE_THRESHOLD = 16;
  const activeTouches = new Map();

  function getContainerFromTarget(target) {
    if (!target) return null;
    let container = target.closest('.media[data-mobile-swipe]');
    if (container) return container;

    const cardRoot = target.closest('.card-wrapper, .card');
    if (!cardRoot) return null;
    container = cardRoot.querySelector('.media[data-mobile-swipe]');
    return container || null;
  }

  function applySlideTransform(container, index, opts = { animate: true }) {
    const track = container.querySelector('.product-card-media__track');
    if (!track) return;

    // toggle animation
    if (!opts.animate) {
      const prevTransition = track.style.transition;
      track.style.transition = 'none';
      const offsetPctNoAnim = index * -100;
      track.style.transform = `translateX(${offsetPctNoAnim}%)`;
      // force layout flush
      track.offsetHeight;
      track.style.transition = prevTransition || '';
    } else {
      // While the step animates, neighbouring slides must stay visible —
      // at rest they are hidden (see component-card.css, "hairline").
      container.classList.add('is-sliding');
      clearTimeout(container._slidingTimer);
      const done = () => {
        clearTimeout(container._slidingTimer);
        track.removeEventListener('transitionend', done);
        container.classList.remove('is-sliding');
      };
      track.addEventListener('transitionend', done);
      // Fallback if transitionend never fires (e.g. transition interrupted).
      container._slidingTimer = setTimeout(done, 700);

      const offsetPct = index * -100;
      track.style.transform = `translateX(${offsetPct}%)`;
    }
  }

  function readIndex(container) {
    const parsed = parseInt(container.getAttribute('data-slide-index'), 10);
    // 0 is a real position (the leading clone), so only a missing or
    // unparseable value falls back to the first real slide.
    return isNaN(parsed) ? 1 : parsed;
  }

  // The clones mirror real slides: DOM position 0 shows the last image,
  // position lastReal + 1 shows the first. Map a clone position to the real
  // slide it duplicates; any other position comes back unchanged.
  function cloneTwin(index, firstRealIndex, lastRealIndex) {
    if (index <= 0) return lastRealIndex;
    if (index > lastRealIndex) return firstRealIndex;
    return index;
  }

  function writeIndex(container, index) {
    container.setAttribute('data-slide-index', String(index));
  }

  // The size row is a :hover swap. On touch, a tap leaves hover stuck on the
  // card and the row stays up, but a swipe makes the browser drop hover as soon
  // as it reads the gesture as a pan. These two keep the row up for a swipe the
  // same way hover does for a tap, and release it when another card is touched.
  let shownSizesWrapper = null;

  function showSizes(container) {
    const wrapper = container.closest('.card-wrapper');
    if (!wrapper || wrapper === shownSizesWrapper) return;

    clearSizes();
    wrapper.classList.add('card-wrapper--show-sizes');
    shownSizesWrapper = wrapper;
  }

  function clearSizes(keepIfContains) {
    if (!shownSizesWrapper) return;
    // Still the card being touched — leave it alone, as hover would.
    if (keepIfContains && shownSizesWrapper.contains(keepIfContains)) return;

    shownSizesWrapper.classList.remove('card-wrapper--show-sizes');
    shownSizesWrapper = null;
  }

  // Slides past the second one ship without a `src` (see
  // snippets/card-product-media-slide.liquid) so a card costs two image
  // requests on load instead of one per product image. Give a slide its real
  // source the moment the carousel comes within one step of it.
  function hydrateSlide(slide) {
    if (!slide) return;
    ensureCardVideoSource(slide.querySelector('video'));

    const img = slide.querySelector('img[data-src]');
    if (!img) return;

    const srcset = img.getAttribute('data-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function hydrateAround(container, index) {
    const track = container.querySelector('.product-card-media__track');
    if (!track) return;

    const slides = track.children;
    for (let i = index - 1; i <= index + 1; i++) {
      if (slides[i]) hydrateSlide(slides[i]);
    }
  }

  function realCount(container) {
    const raw = container.getAttribute('data-slide-count');
    const parsed = parseInt(raw, 10);
    return isNaN(parsed) ? 1 : parsed;
  }

  // highlight the active slide so video can be interacted with
  function setActiveSlide(container, index) {
    const track = container.querySelector('.product-card-media__track');
    if (!track) return;

    const slides = track.children;
    if (!slides) return;

    // Remove is-active from all
    for (let i = 0; i < slides.length; i++) {
      slides[i].classList.remove('is-active');
    }

    // Add is-active to the currently visible DOM index
    if (slides[index]) {
      slides[index].classList.add('is-active');
    }

    // Swiping doesn't scroll, so the scroll-driven video helper never runs —
    // start the slide we landed on here, and leave the rest alone.
    for (let i = 0; i < slides.length; i++) {
      const video = slides[i].querySelector('video');
      if (!video) continue;

      if (i === index) {
        ensureCardVideoSource(video);
        video.play().catch(() => {});
      } else if (!video.paused) {
        video.pause();
      }
    }
  }

  function registerTouch(touch) {
    if (!mobileQuery.matches) return;

    const container = getContainerFromTarget(touch.target);
    if (!container) return;

    const track = container.querySelector('.product-card-media__track');
    if (!track) return;

    const slides = track.children;
    if (!slides || slides.length < 2) return;

    activeTouches.set(touch.identifier, {
      container,
      startX: touch.clientX,
      startY: touch.clientY,
      isHorizontal: false,
    });
  }

  function updateTouchState(touch) {
    const state = activeTouches.get(touch.identifier);
    if (!state || state.isHorizontal) return;

    const deltaX = touch.clientX - state.startX;
    const deltaY = touch.clientY - state.startY;

    // detect horizontal intent
    if (
      Math.abs(deltaX) > Math.abs(deltaY) &&
      Math.abs(deltaX) >= ACTIVATE_THRESHOLD
    ) {
      state.isHorizontal = true;
      // The slide being swiped to may still be deferred. Start it here, on
      // intent rather than at the end of the gesture, so it has the rest of
      // the swipe plus the transition to arrive — and so a vertical scroll
      // that merely began on a card fetches nothing.
      hydrateAround(state.container, readIndex(state.container));
      showSizes(state.container);
    } else if (
      Math.abs(deltaY) > Math.abs(deltaX) &&
      Math.abs(deltaY) > ACTIVATE_THRESHOLD
    ) {
      // user is scrolling vertically → abort swipe
      activeTouches.delete(touch.identifier);
    }
  }

  function resolveTouch(touch) {
    const state = activeTouches.get(touch.identifier);
    if (!state) return;
    activeTouches.delete(touch.identifier);

    if (!state.isHorizontal) return;
    if (!document.contains(state.container)) return;

    const container = state.container;
    const rc = realCount(container);      // # of real slides
    const lastRealIndex = rc;             // in DOM indexing we mapped: 1..rc are real
    const firstRealIndex = 1;

    const deltaX = touch.clientX - state.startX;
    if (Math.abs(deltaX) < TOGGLE_THRESHOLD) {
      return;
    }

    let index = readIndex(container);

    // A previous swipe may still be animating onto a clone, its snap back to
    // the twin real slide not yet run. Do that snap now so this swipe starts
    // from a real slide — otherwise fast repeated swipes keep incrementing
    // past the clone and the track runs off its own end onto nothing.
    const startIndex = cloneTwin(index, firstRealIndex, lastRealIndex);
    if (startIndex !== index) {
      index = startIndex;
      writeIndex(container, index);
      applySlideTransform(container, index, { animate: false });
      setActiveSlide(container, index);
    }

    const goingLeft = deltaX < 0; // swipe left = next
    index += goingLeft ? 1 : -1;

    writeIndex(container, index);
    applySlideTransform(container, index, { animate: true });
    setActiveSlide(container, index); // mark active immediately (during animation)
    hydrateAround(container, index);

    const track = container.querySelector('.product-card-media__track');
    if (!track) return;

    track.addEventListener(
      'transitionend',
      function handler() {
        track.removeEventListener('transitionend', handler);

        // A later swipe may have moved on while this transition ran — it owns
        // the position now, and brings its own snap.
        if (readIndex(container) !== index) return;

        // Landed on a clone: jump to the real slide it duplicates, without
        // animating, so the loop reads as continuous.
        const snapIndex = cloneTwin(index, firstRealIndex, lastRealIndex);
        if (snapIndex === index) return;

        writeIndex(container, snapIndex);
        applySlideTransform(container, snapIndex, { animate: false });
        setActiveSlide(container, snapIndex); // update which slide is interactive
        hydrateAround(container, snapIndex);
      },
      { once: true }
    );

    // prevent accidental "click-through" nav after swipe
    container.dataset.swipeSuppressClick = 'true';
  }

  function onTouchStart(event) {
    if (!mobileQuery.matches) return;
    clearSizes(event.target);
    for (let i = 0; i < event.changedTouches.length; i++) {
      registerTouch(event.changedTouches[i]);
    }
  }

  function onTouchMove(event) {
    if (!mobileQuery.matches) return;
    for (let i = 0; i < event.changedTouches.length; i++) {
      updateTouchState(event.changedTouches[i]);
    }
  }

  function onTouchEnd(event) {
    if (!mobileQuery.matches) return;
    for (let i = 0; i < event.changedTouches.length; i++) {
      resolveTouch(event.changedTouches[i]);
    }
  }

  function onTouchCancel(event) {
    for (let i = 0; i < event.changedTouches.length; i++) {
      activeTouches.delete(event.changedTouches[i].identifier);
    }
  }

  function onClick(event) {
    const container = getContainerFromTarget(event.target);
    if (!container) return;

    if (container.dataset.swipeSuppressClick === 'true') {
      event.preventDefault();
      event.stopPropagation();
      delete container.dataset.swipeSuppressClick;
    }
  }

  // Desktop swaps the image on hover via CSS instead — no swipe handlers there.
  if (!isTouchDevice) return;

  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchmove', onTouchMove, { passive: true });
  document.addEventListener('touchend', onTouchEnd, { passive: true });
  document.addEventListener('touchcancel', onTouchCancel, { passive: true });
  document.addEventListener('click', onClick, true);
})();

// Card videos ship without a <source src> (see card-product-media-slide.liquid)
// so a grid of them doesn't open one media loader per card. Attach the source
// the first time the video is actually meant to play. With preload="none" the
// load() below only resets the element — bytes move on play().
//
// Quality: where the browser plays HLS natively (Safari, Chrome 14x+), the
// master manifest is NOT handed over as-is. Its adaptive player starts every
// clip on the 320x480 rendition — the whole first loop of a ~10s clip is
// visibly soft — and then pulls the 720x1080 segments anyway, so a card cost
// ~1.2 MB of blur plus ~10 MB of sharp. Instead we read the manifest and play
// the one rendition that fits the card: the smallest whose width covers the
// card's width x devicePixelRatio (DPR capped at 2 on desktop, 1.5 on phones).
// Desktop 2x lands on 720x1080, phones stay on 320x480. Save-Data and slow
// connections get the smallest. Browsers without native HLS (Firefox) keep
// the mp4 fallback, unchanged.
const cardVideoCanPlayHls = !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl');
const cardVideoManifests = new Map();

function fetchCardVideoRenditions(manifestUrl) {
  if (!cardVideoManifests.has(manifestUrl)) {
    const request = fetch(manifestUrl)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const lines = text.split('\n').map((line) => line.trim());
        const renditions = [];
        lines.forEach((line, i) => {
          if (!line.startsWith('#EXT-X-STREAM-INF')) return;
          const resolution = line.match(/RESOLUTION=(\d+)x(\d+)/);
          const uri = lines.slice(i + 1).find((next) => next && !next.startsWith('#'));
          if (!resolution || !uri) return;
          renditions.push({ width: parseInt(resolution[1], 10), url: new URL(uri, manifestUrl).href });
        });
        return renditions.sort((a, b) => a.width - b.width);
      });
    // A failed fetch must not stick: the next attempt falls back or retries.
    request.catch(() => cardVideoManifests.delete(manifestUrl));
    cardVideoManifests.set(manifestUrl, request);
  }
  return cardVideoManifests.get(manifestUrl);
}

function pickCardVideoRendition(video, renditions) {
  if (!renditions.length) return null;

  // Save-Data or a slow link: the lightest rendition, as before.
  const connection = navigator.connection;
  if (connection && (connection.saveData || /2g|3g/.test(connection.effectiveType || ''))) {
    return renditions[0];
  }

  // Slides that aren't showing measure 0 wide; the card itself has the width.
  const box = video.closest('.card-wrapper') || video;
  const cssWidth = video.getBoundingClientRect().width || box.getBoundingClientRect().width || 400;

  // Phones cap DPR at 1.5, which keeps a ~195px card on the 320 rendition
  // (~4 MB for a 10s clip) instead of the 480 one (~9 MB) on mobile data.
  // Desktop/tablet cap at 2 and get the 720 rendition on retina screens.
  const dprCap = window.matchMedia('(max-width: 749px)').matches ? 1.5 : 2;
  const needed = cssWidth * Math.min(window.devicePixelRatio || 1, dprCap);

  // 0.9: a 716px slot on a 2x desktop takes the 720 rendition, not the next up.
  return renditions.find((rendition) => rendition.width >= needed * 0.9) || renditions[renditions.length - 1];
}

function ensureCardVideoSource(video) {
  if (!video || video.dataset.sourceState) return;

  // Every source, in order: the HLS manifest first where the shop has one,
  // then the mp4 fallback.
  const sources = Array.from(video.querySelectorAll('source[data-src]'));
  if (!sources.length) return;

  const poster = video.getAttribute('data-poster');
  if (poster) {
    video.setAttribute('poster', poster);
    video.removeAttribute('data-poster');
  }

  const attachAll = () => {
    // Coming from the async path, a pending play() may be waiting (see below).
    const shouldPlay = video.dataset.sourceState === 'pending' && !video.paused;
    sources.forEach((source) => {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
    });
    video.dataset.sourceState = 'ready';
    video.load();
    if (shouldPlay) video.play().catch(() => {});
  };

  const hlsSource = sources.find((source) => /\.m3u8(\?|$)/.test(source.getAttribute('data-src')));
  if (!hlsSource || !cardVideoCanPlayHls) {
    attachAll();
    return;
  }

  video.dataset.sourceState = 'pending';
  const manifestUrl = new URL(hlsSource.getAttribute('data-src'), window.location.href).href;

  fetchCardVideoRenditions(manifestUrl)
    .then((renditions) => {
      const rendition = pickCardVideoRendition(video, renditions);
      if (!rendition) return attachAll();

      // Callers play() straight after this function returns. That play() is
      // still pending on a source-less element, which leaves `paused` false —
      // so it tells us whether the video should start once the source is in.
      // load() rejects that pending promise; play again if it was wanted.
      const shouldPlay = !video.paused;
      sources.forEach((source) => source.remove());
      video.src = rendition.url;
      video.dataset.sourceState = 'ready';
      video.load();
      if (shouldPlay) video.play().catch(() => {});
    })
    .catch(attachAll);
}

// Product card video autoplay helper
// Nudges play() on scroll for videos below the fold that miss native autoplay.
// Checks both vertical and horizontal bounds so off-screen slider slides are skipped.
(function () {
  var selector = '.product-card-media__slide video';

  // A slide can sit inside the viewport and still be invisible: on desktop the
  // slides are stacked at opacity 0 and the clones are display:none. Playing
  // those would pull down a video nobody can see.
  function slideIsVisible(video) {
    var slide = video.closest ? video.closest('.product-card-media__slide') : null;
    if (!slide) return true;
    var style = window.getComputedStyle(slide);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function playVisibleVideos() {
    var videos = document.querySelectorAll(selector);
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      var rect = video.getBoundingClientRect();
      var inViewport = rect.top < window.innerHeight && rect.bottom > 0
                    && rect.left < window.innerWidth && rect.right > 0
                    && slideIsVisible(video);
      if (inViewport && video.paused) {
        ensureCardVideoSource(video);
        video.play().catch(function () {});
      } else if (!inViewport && !video.paused) {
        video.pause();
      }
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        playVisibleVideos();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  playVisibleVideos();
  setTimeout(playVisibleVideos, 1000);

  // Desktop: on card hover, play video in the second slide.
  // Guard: `mouseenter` on document can fire with non-Element targets
  // (Text nodes, the Document itself) which don't have .closest —
  // skip those so we don't throw a TypeError.
  document.addEventListener('mouseenter', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || typeof t.closest !== 'function') return;
    var wrapper = t.closest('.card-wrapper');
    if (!wrapper) return;
    var video = wrapper.querySelector(
      '.product-card-media__slide[data-clone="false"][data-slide-pos="2"] video'
    );
    if (video && video.paused) {
      ensureCardVideoSource(video);
      video.play().catch(function () {});
    }
  }, true);
})();

// Update Stock Availability

function updateAllStockAvailability(value, variants) {
  const variant = variants.find(variant => variant.title === value);

  const url = new URL(window.location.href);

  url.searchParams.set('variant', variant.id);

  window.history.replaceState({}, '', url);
  window.location.reload();
}


// Cart upsell — reveal N random products from the server-rendered pool.
//
// The pool is rendered by snippets/cart-upsell.liquid with every row hidden;
// picking the visible ones here rather than in Liquid keeps Shopify's
// full-page cache from pinning the same products for the whole cache window.
(function () {
  const REVEALED = 'data-cart-upsell-revealed';

  function revealUpsells(root) {
    root.querySelectorAll('[data-cart-upsell]').forEach((box) => {
      if (box.hasAttribute(REVEALED)) return;

      const items = Array.from(box.querySelectorAll('[data-cart-upsell-item]'));
      if (!items.length) return;

      const show = parseInt(box.getAttribute('data-upsell-show'), 10) || 4;

      // Fisher-Yates, then the first `show` survive.
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
      items.forEach((item, index) => {
        item.hidden = index >= show;
      });

      // Number them by the order they actually appear in. The shuffle above
      // reorders the array, not the DOM, so the array position would not
      // match what the customer sees top to bottom.
      box
        .querySelectorAll('[data-cart-upsell-item]:not([hidden])')
        .forEach((item, position) => {
          // Carry the display position (1-based) through to the product page
          // so an add off this strip can be attributed — see the
          // upsell-attribution block below.
          item.querySelectorAll('a[href]').forEach((link) => {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            url.searchParams.set('upsell', '1');
            url.searchParams.set('upsell_index', String(position + 1));
            link.setAttribute('href', url.pathname + url.search);
          });
        });

      box.setAttribute(REVEALED, 'true');
      box.hidden = false;
    });
  }

  function init() {
    revealUpsells(document);

    // The drawer replaces its own innerHTML after every cart change, which
    // does not re-run scripts and brings back a fresh, fully hidden pool —
    // so watch for one and roll again.
    const drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!drawer || !window.MutationObserver) return;

    new MutationObserver(() => revealUpsells(drawer)).observe(drawer, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// Upsell attribution — a cart line added off the back of the "YOU MIGHT
// LIKE" strip carries `_upsell` and `_upsell_index` line item properties.
//
// The strip links to the product page rather than adding blind (34 of the 48
// products in that collection have size variants, so there is no single
// obvious variant), which means attribution has to survive the hop. The link
// carries the display position; here it becomes hidden inputs on the product
// form, so whichever variant the customer picks, the property rides along.
//
// Properties prefixed with `_` are hidden from the cart and checkout UI but
// kept on the order — which is what makes them usable for analytics.
//
// The same hop carries recommendation attribution: a click on a card in the
// PDP "You may also like" section or the search drawer's empty-state best
// sellers lands with `recommendation=1`, `recommendation_index` (1-based card
// position) and `recommendation_from` (the recommending product's handle, or
// "search-drawer"),
// which become `_recommendation`, `_recommendation_index` and
// `_recommendation_from` — see the link decoration block below.
(function () {
  const params = new URLSearchParams(window.location.search);

  // [line item property, value] pairs for whichever attribution this visit
  // arrived with. Empty values are left off.
  const properties = [];
  if (params.get('upsell') === '1') {
    properties.push(['_upsell', 'true'], ['_upsell_index', params.get('upsell_index')]);
  }
  if (params.get('recommendation') === '1') {
    properties.push(
      ['_recommendation', 'true'],
      ['_recommendation_index', params.get('recommendation_index')],
      ['_recommendation_from', params.get('recommendation_from')]
    );
  }
  const stamped = properties.filter(([, value]) => value);
  if (!stamped.length) return;

  function stampForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      stamped.forEach(([key, value]) => {
        const name = `properties[${key}]`;
        if (form.querySelector(`input[name="${name}"]`)) return;

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stampForms);
  } else {
    stampForms();
  }

  // Variant switching can re-render the buy buttons, taking the inputs with
  // them, so re-stamp whenever the form subtree changes.
  const scope = document.querySelector('main') || document.body;
  if (scope && window.MutationObserver) {
    new MutationObserver(stampForms).observe(scope, { childList: true, subtree: true });
  }
})();


// Recommendation links — tag product links in any container carrying
// `data-recommendation-source` so the attribution block above can stamp
// `_recommendation` on the next product page. Two containers do:
//   - the PDP "You may also like" section (sections/related-products.liquid),
//     source = the recommending product's handle;
//   - the empty-state best sellers in the search drawer
//     (snippets/header-search.liquid), source = "search-drawer".
//
// Both sets of cards arrive via their own fetch after page load,
// so the links are decorated at interaction time rather than on render:
// mousedown covers left, middle and modifier clicks before the browser reads
// the href; keydown covers Enter on a focused card; click is the fallback.
(function () {
  function decorate(event) {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    const box = link.closest('[data-recommendation-source]');
    if (!box) return;

    const url = new URL(link.getAttribute('href'), window.location.origin);
    if (!url.pathname.includes('/products/')) return;

    const item = link.closest('.grid__item');
    const items = Array.from(box.querySelectorAll('.grid__item'));

    url.searchParams.set('recommendation', '1');
    if (item) url.searchParams.set('recommendation_index', String(items.indexOf(item) + 1));
    url.searchParams.set('recommendation_from', box.getAttribute('data-recommendation-source'));
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  document.addEventListener('mousedown', decorate, true);
  document.addEventListener('click', decorate, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') decorate(event);
  }, true);
  document.addEventListener('touchstart', decorate, { capture: true, passive: true });
})();


// Cart upsell — add to cart straight from the strip.
//
// Mirrors assets/product-form.js: the same FormData + `sections` payload, so
// the response carries fresh drawer markup and `renderContents` swaps it in.
// The `_upsell` / `_upsell_index` line item properties are attached here, at
// the point of the add, so the attribution is exact.
(function () {
  function findVariantId(item) {
    const checked = item.querySelector('[data-upsell-variants] input[type="radio"]:checked');
    if (checked) return checked.value;

    const single = item.querySelector('input[data-upsell-variant]');
    return single ? single.value : null;
  }

  function position(item) {
    const box = item.closest('[data-cart-upsell]');
    if (!box) return '';
    const shown = Array.from(box.querySelectorAll('[data-cart-upsell-item]:not([hidden])'));
    return String(shown.indexOf(item) + 1);
  }

  async function addToCart(button) {
    const item = button.closest('[data-cart-upsell-item]');
    const variantId = item && findVariantId(item);
    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const label = button.querySelector('.cart-upsell__add-label');
    const original = label ? label.textContent : '';

    button.setAttribute('aria-disabled', 'true');
    if (label) label.textContent = 'ADDING…';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('properties[_upsell]', 'true');
    formData.append('properties[_upsell_index]', position(item));

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await response.json();

      if (data.status) {
        if (label) label.textContent = 'UNAVAILABLE';
        return;
      }

      if (cart && typeof cart.renderContents === 'function') {
        // Re-renders the drawer, which also brings a fresh upsell pool.
        cart.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      if (label) label.textContent = original;
      button.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-upsell-add]');
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  });
})();
